
import store from "../../redux/store";

let currentValue = true;

const isInitalHandler = (callbacks) => {
    let previousValue = currentValue;
    currentValue = store.getState().isInitial;
    // first-timer cb execution after user consent
    if (previousValue !== currentValue) {
        callbacks.forEach(cb => {
            cb();  
        });
    }
};

export default isInitalHandler;